/* GPROPERTY-PM01-VERIFIED-UI-01
 * Only the canonical native LittleGWebSession may call Core's authenticated
 * project-evidence route. Never trust or submit hand-drawn map coordinates.
 * Results remain preliminary and do not create map boundaries or customer jobs.
 */
(function(window,document){
  'use strict';
  var WORKSPACE='[data-gproperty-map-workspace][data-product="gproperty"]';
  var EVIDENCE=/^evidence_[A-Za-z0-9_-]{1,120}$/;
  var mounted=new WeakSet();
  var API='https://api.glhksolution.com/v1/gcitypartners/professional-area/pm01';
  function one(el,sel){return el.querySelector(sel);}
  function finitePositive(value){return typeof value==='number'&&Number.isFinite(value)&&value>0;}
  function validResult(payload,id){
    var r=payload&&payload.data;
    var c=r&&r.computation,p=r&&r.provenance,l=r&&r.limitations;
    return payload&&payload.ok===true&&r.contract==='gproperty_pm01_preliminary_result_v1'&&
      r.status==='preliminary_not_cadastral'&&p&&p.evidence_id===id&&
      p.evidence_status==='verified'&&typeof p.measurement_source_id==='string'&&
      c&&c.algorithm==='planar_shoelace_v1'&&
      /^(EPSG:2326|EPSG:4547)$/.test(c.crs_id||'')&&
      finitePositive(c.area_m2)&&finitePositive(c.perimeter_m)&&
      finitePositive(c.exterior_perimeter_m)&&
      typeof c.holes_perimeter_m==='number'&&Number.isFinite(c.holes_perimeter_m)&&c.holes_perimeter_m>=0&&
      c.area_basis==='projected_grid_not_ground'&&
      c.perimeter_basis==='exterior_plus_hole_boundaries'&&
      l&&l.map_overlay_ready===false&&l.statutory_approved===false&&
      l.projection_scale_correction_applied===false&&l.measurement_uncertainty_evaluated===false&&
      l.formal_report_ready===false&&l.professional_review_required===true;
  }
  function mount(workspace){
    if(!workspace||mounted.has(workspace))return false;
    var owner=one(workspace,'[data-spatial-professional]');
    if(!owner)return false;
    var form=one(owner,'[data-spatial-pm01-form]'),
        input=one(owner,'[data-spatial-pm01-id]'),
        submit=one(owner,'[data-spatial-pm01-submit]'),
        status=one(owner,'[data-spatial-pm01-status]'),
        result=one(owner,'[data-spatial-pm01-result]'),
        area=one(owner,'[data-spatial-pm01-area]'),
        perimeter=one(owner,'[data-spatial-pm01-perimeter]'),
        inner=one(owner,'[data-spatial-pm01-inner]'),
        provenance=one(owner,'[data-spatial-pm01-provenance]');
    if(![form,input,submit,status,result,area,perimeter,inner,provenance].every(Boolean))return false;
    var zh=owner.closest('[data-spatial-language="zh"]')!==null;
    var runId=0, pending=false;
    function say(en,cn){status.textContent=zh?cn:en;}
    function wipe(){
      result.hidden=true;area.textContent='—';perimeter.textContent='—';inner.textContent='—';
      provenance.textContent='';owner.dataset.pm01ResultState='empty';
    }
    function numbers(v){
      return new Intl.NumberFormat(zh?'zh-HK':'en-HK',{maximumFractionDigits:2}).format(v);
    }
    document.addEventListener('littleg:web-session-change',function(){
      runId++;pending=false;submit.disabled=false;wipe();
      say('Session changed. Retrieve evidence again if authorized.','帳戶狀態已變更，請重新授權讀取。');
    });
    form.addEventListener('submit',async function(event){
      event.preventDefault();
      if(pending)return;
      var id=String(input.value||'').trim();
      runId++;var thisRun=runId;
      wipe();
      if(!EVIDENCE.test(id)){
        say('Enter a valid project evidence ID.','請輸入正確的項目證據編號。');
        return;
      }
      var session=window.LittleGWebSession;
      if(!session||typeof session.authenticatedFetch!=='function'){
        say('Sign-in service is unavailable. Please retry later.','登入服務暫時未能使用，請稍後再試。');
        return;
      }
      pending=true;submit.disabled=true;
      say('Checking verified project evidence…','正在核對項目及專業測量證據…');
      try{
        var response=await session.authenticatedFetch(API+'?evidence_id='+encodeURIComponent(id),{
          method:'GET',headers:{Accept:'application/json'},cache:'no-store',redirect:'error'
        });
        if(thisRun!==runId)return;
        if(!response.ok){
          if(response.status===401) say('Sign in with the authorized LittleG account.','請先登入已獲授權的 LittleG 帳戶。');
          else if(response.status===403||response.status===404) say('This account cannot access the evidence.','目前帳戶無權查閱此證據，或證據不存在。');
          else if(response.status===409) say('Verified project evidence is incomplete.','項目或專業測量證據未達核實要求。');
          else say('Professional calculation is not available yet.','專業計算暫時未開放。');
          return;
        }
        // One bounded JSON response; never inject arbitrary server HTML into the map.
        var body=await response.json();
        if(thisRun!==runId)return;
        if(!validResult(body,id)){
          say('Professional evidence response could not be verified.','專業證據回應未能核實。');
          return;
        }
        var record=body.data;
        area.textContent=numbers(record.computation.area_m2)+' m²';
        perimeter.textContent=numbers(record.computation.exterior_perimeter_m)+' m';
        inner.textContent=numbers(record.computation.holes_perimeter_m)+' m';
        provenance.textContent=(zh?'測量來源：':'Measurement source: ')+
          record.provenance.measurement_source_id+' · '+
          record.computation.crs_id;
        result.hidden=false;
        owner.dataset.pm01ResultState='verified_preliminary_no_map_overlay';
        say('PM01 preliminary result. Not a cadastral or statutory measurement.','PM01 專業預檢數值，並非法定或地籍測量成果。');
      }catch(_){
        if(thisRun!==runId)return;
        say('Unable to retrieve verified evidence now.','目前未能讀取已核實測量證據。');
      }finally{
        if(thisRun===runId){pending=false;submit.disabled=false;}
      }
    });
    mounted.add(workspace);
    wipe();
    return true;
  }
  function ready(){document.querySelectorAll(WORKSPACE).forEach(mount);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);
  else ready();
  window.GPropertySpatialPm01=Object.freeze({mount:mount});
})(window,document);
